const PAYMENT_DISPLAY_TYPES = {
    NONE: 'none',
    PRICE_INCREASE_NO_REMAINING_INSTALLMENTS: 'pi_no_installments',
    PRICE_DECREASE_NO_REMAINING_INSTALLMENTS: 'pd_no_installments',
    PRICE_DECREASE_ANNUAL: 'pd_annual',
    PRICE_INCREASE_MORE_INSTALLMENTS_REMAINING: 'pi_more_installments_remaining',
    PRICE_DECREASE_MORE_INSTALLMENTS_REMAINING: 'pd_more_installments_remaining',
    PRICE_INCREASE_ONE_INSTALLMENT_REMAINING: 'pi_one_installment_remaining',
    PRICE_DECREASE_ONE_INSTALLMENT_REMAINING: 'pd_one_installment_remaining'
};

const PRODUCT_NAMES = {
    CAR_INSURANCE: 'car insurance',
    HOME_INSURANCE: 'home insurance',
    TRAVEL_INSURANCE: 'travel insurance',
    MEDICAL_INSURANCE: 'Health Insurance'
};

const PRODUCT_CODES = {
    PRIVATE_MOTOR: 'PrivateMotor',
    PRIVATE_HOME: 'PrivateHome',
    PRIVATE_TRAVEL: 'PrivateTravel',
    PRIVATE_MEDICAL: 'PrivateMedical'
};

const TRAVEL_COVER_TYPES = {
    SINGLE: 'Single (One trip)',
    ANNUAL: 'Annual (Multi-trip)'
};

const PRODUCT_TYPES = {
    CURRENT_POLICY: 'current policy',
    RENEWAL_PROPOSAL: 'renewal proposal',
    RENEWED_POLICY: 'renewed policy'
};

const RENEWED_POLICY_HEADER = 'Your renewed policy';

const VEHICLE_CHANGES = {
    REGISTRATION: 'registrationNumber',
    VEHICLE: 'vehicle',
    MILEAGE: 'mileage',
    VEHICLE_USE: 'vehicleUse',
    PARKING_TYPE: 'vehicleParkingType',
    ADDED_MODIFICATION: 'addedModification',
    REMOVED_MODIFICATION: 'removedModification'
};

const DRIVER_CHANGES = {
    ADDED_DRIVER: 'addedDriver',
    REMOVED_DRIVER: 'removedDriver'
};

const COVERAGES = {
    ADDED: 'coverageAdded',
    REMOVED: 'coverageRemoved',
    MODIFIED_VOLUNTARY_AD: 'voluntaryExcess',
    MODIFIED_COMPULSORY_AD: 'compulsoryExcess',
    MODIFIED_BREAKDOWN_LEVEL: 'breakdownCoverLevel',
    MODIFIED_FIRE_THEFT: 'fireAndTheftExcess',
    CURRENT_PNCD_PRICE: 'pncdPrice',
};

const POLICY_CHANGES = {
    ADD_DRIVER: 'additional driver added',
    REMOVE_DRIVER: 'additional driver removed',
    REPLACE_VEHICLE: 'vehicle changed',
    REG_CHANGE: 'vehicle registration changed',
    MILEAGE: 'change of mileage',
    VEHICLE_USE: 'change of vehicle use',
    PARKING_TYPE: 'change of parking type',
    ADDED_MODIFICATION: 'vehicle modification added',
    REMOVED_MODIFICATION: 'vehicle modification removed',
    COVERAGE_ADDED: 'coverage added',
    COVERAGE_REMOVED: 'coverage removed',
    COVERAGE_MODIFIED_VOLUNTARY_AD: 'modified voluntary ad',
    COVERAGE_MODIFIED_BREAKDOWN_LEVEL: 'modified breakdown cover level'
};

export default {
    CHANGE_EMAIL_LINK: 'https://www.saga.co.uk/my/account/edit-email-address',
    CHANGE_PASSWORD_LINK: 'https://www.saga.co.uk/my/account/reset-password',
    CHANGE_COMM_PREF_LINK: 'https://www.saga.co.uk/my/account/contact-preferences',
    CAR_POLICY_BOOK_LINK: 'https://www.saga.co.uk/insurance/car-insurance/policy-books',
    HOME_POLICY_BOOK_LINK: 'https://www.saga.co.uk/insurance/home-insurance/policy-documentation',
    LANDLORD_POLICY_BOOK_LINK: 'https://www.saga.co.uk/insurance/landlord-insurance/policy-documentation',
    DELETE_COUNT: 1,
    PREFIX_TYPE: 'Online ',
    SELF_SERVE_EVENT: 'selfServe',
    PAYMENT_DISPLAY_TYPES,
    PRODUCT_NAMES,
    PRODUCT_CODES,
    TRAVEL_COVER_TYPES,
    PRODUCT_TYPES,
    RENEWED_POLICY_HEADER,
    VEHICLE_CHANGES,
    DRIVER_CHANGES,
    COVERAGES,
    POLICY_CHANGES
};
